"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosAPI = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const operation_1 = require("../../../operation");
const chain_1 = __importDefault(require("../chain/chain"));
class CosmosAPI {
    constructor(currencyId) {
        this.getAccountInfo = (address, currency) => __awaiter(this, void 0, void 0, function* () {
            try {
                const [balances, blockHeight, txs, delegations, redelegations, unbondings, withdrawAddress] = yield Promise.all([
                    this.getAllBalances(address, currency),
                    this.getHeight(),
                    this.getTransactions(address, 100),
                    this.getDelegations(address, currency),
                    this.getRedelegations(address),
                    this.getUnbondings(address),
                    this.getWithdrawAddress(address),
                ]);
                return {
                    balances,
                    blockHeight,
                    txs,
                    delegations,
                    redelegations,
                    unbondings,
                    withdrawAddress,
                };
            }
            catch (e) {
                throw new Error(`"Error during cosmos synchronization: "${e.message}`);
            }
        });
        this.getAccount = (address) => __awaiter(this, void 0, void 0, function* () {
            const response = {
                accountNumber: 0,
                sequence: 0,
            };
            try {
                const { data } = yield (0, network_1.default)({
                    method: "GET",
                    url: `${this.defaultEndpoint}/cosmos/auth/${this.version}/accounts/${address}`,
                });
                if (data.account.account_number) {
                    response.accountNumber = parseInt(data.account.account_number);
                }
                if (data.account.sequence) {
                    response.sequence = parseInt(data.account.sequence);
                }
                // eslint-disable-next-line no-empty
            }
            catch (e) { }
            return response;
        });
        this.getChainId = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/base/tendermint/${this.version}/node_info`,
            });
            return data.default_node_info.network;
        });
        this.getHeight = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/base/tendermint/${this.version}/blocks/latest`,
            });
            return parseInt(data.block.header.height);
        });
        this.getAllBalances = (address, currency) => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/bank/${this.version}/balances/${address}`,
            });
            let amount = new bignumber_js_1.default(0);
            for (const elem of data.balances) {
                if (elem.denom === currency.units[1].code)
                    amount = amount.plus(elem.amount);
            }
            return amount;
        });
        this.getDelegations = (address, currency) => __awaiter(this, void 0, void 0, function* () {
            const delegations = [];
            const { data: data1 } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/staking/${this.version}/delegations/${address}`,
            });
            data1.delegation_responses = data1.delegation_responses.filter(d => d.balance.amount !== "0");
            let status = "unbonded";
            const statusMap = {
                BOND_STATUS_UNBONDED: "unbonded",
                BOND_STATUS_UNBONDING: "unbonding",
                BOND_STATUS_BONDED: "bonded",
            };
            for (const d of data1.delegation_responses) {
                const { data: data2 } = yield (0, network_1.default)({
                    method: "GET",
                    url: `${this.defaultEndpoint}/cosmos/staking/${this.version}/validators/${d.delegation.validator_address}`,
                });
                status = statusMap[data2.validator.status] || "unbonded";
                delegations.push({
                    validatorAddress: d.delegation.validator_address,
                    amount: d.balance.denom === currency.units[1].code
                        ? new bignumber_js_1.default(d.balance.amount)
                        : new bignumber_js_1.default(0),
                    pendingRewards: new bignumber_js_1.default(0),
                    status: status,
                });
            }
            const { data: data3 } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/distribution/${this.version}/delegators/${address}/rewards`,
            });
            for (const r of data3.rewards) {
                for (const d of delegations) {
                    if (r.validator_address === d.validatorAddress) {
                        for (const reward of r.reward) {
                            if (reward.denom === currency.units[1].code)
                                d.pendingRewards = d.pendingRewards.plus(new bignumber_js_1.default(reward.amount).integerValue(bignumber_js_1.default.ROUND_CEIL));
                        }
                    }
                }
            }
            return delegations;
        });
        this.getRedelegations = (address) => __awaiter(this, void 0, void 0, function* () {
            const redelegations = [];
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/staking/${this.version}/delegators/${address}/redelegations`,
            });
            for (const r of data.redelegation_responses) {
                for (const entry of r.entries) {
                    redelegations.push({
                        validatorSrcAddress: r.redelegation.validator_src_address,
                        validatorDstAddress: r.redelegation.validator_dst_address,
                        amount: new bignumber_js_1.default(entry.redelegation_entry.initial_balance),
                        completionDate: new Date(entry.redelegation_entry.completion_time),
                    });
                }
            }
            return redelegations;
        });
        this.getUnbondings = (address) => __awaiter(this, void 0, void 0, function* () {
            const unbondings = [];
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/staking/${this.version}/delegators/${address}/unbonding_delegations`,
            });
            for (const u of data.unbonding_responses) {
                for (const entry of u.entries) {
                    unbondings.push({
                        validatorAddress: u.validator_address,
                        amount: new bignumber_js_1.default(entry.initial_balance),
                        completionDate: new Date(entry.completion_time),
                    });
                }
            }
            return unbondings;
        });
        this.getWithdrawAddress = (address) => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.defaultEndpoint}/cosmos/distribution/${this.version}/delegators/${address}/withdraw_address`,
            });
            return data.withdraw_address;
        });
        this.getTransactions = (address, paginationSize) => __awaiter(this, void 0, void 0, function* () {
            const senderTxs = yield this.fetchAllTransactions(address, "message.sender", paginationSize);
            const recipientTxs = yield this.fetchAllTransactions(address, "transfer.recipient", paginationSize);
            return [...senderTxs, ...recipientTxs];
        });
        this.broadcast = ({ signedOperation: { operation, signature } }) => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "POST",
                url: `${this.defaultEndpoint}/cosmos/tx/${this.version}/txs`,
                data: {
                    tx_bytes: Array.from(Uint8Array.from(Buffer.from(signature, "hex"))),
                    mode: "BROADCAST_MODE_SYNC",
                },
            });
            if (data.tx_response.code != 0) {
                // error codes: https://github.com/cosmos/cosmos-sdk/blob/master/types/errors/errors.go
                throw new Error("invalid broadcast return (code: " +
                    (data.tx_response.code || "?") +
                    ", message: '" +
                    (data.tx_response.raw_log || "") +
                    "')");
            }
            return (0, operation_1.patchOperationWithHash)(operation, data.tx_response.txhash);
        });
        /** Simulate a transaction on the node to get a precise estimation of gas used */
        this.simulate = (tx_bytes) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield (0, network_1.default)({
                    method: "POST",
                    url: `${this.defaultEndpoint}/cosmos/tx/${this.version}/simulate`,
                    data: {
                        tx_bytes,
                    },
                });
                if (data && data.gas_info && data.gas_info.gas_used) {
                    return new bignumber_js_1.default(data.gas_info.gas_used);
                }
                else {
                    throw new Error("No gas used returned from lcd");
                }
            }
            catch (e) {
                throw new Error("Tx simulation failed");
            }
        });
        const crypto = (0, chain_1.default)(currencyId);
        this.defaultEndpoint = crypto.lcd;
        this.version = crypto.version;
    }
    fetchAllTransactions(address, filterOn, paginationSize) {
        return __awaiter(this, void 0, void 0, function* () {
            let txs = [];
            try {
                let total;
                let previousTxCall = null;
                let paginationOffset = 0;
                do {
                    const response = yield this.fetchTransactions(this.defaultEndpoint, filterOn, address, {
                        "pagination.limit": paginationSize,
                        "pagination.offset": paginationOffset,
                        "pagination.reverse": true,
                    });
                    if (previousTxCall &&
                        previousTxCall.length === txs.length &&
                        response.txs[0] &&
                        previousTxCall[0].txhash === response.txs[0].txhash) {
                        // Means we are getting the same thing... prevents an infinite loop
                        break;
                    }
                    paginationOffset += paginationSize;
                    total = response.total;
                    previousTxCall = response.txs;
                    txs = [...txs, ...response.txs];
                } while (txs.length < total);
                // The right condition should be nextPageToken != null but next_key isn't returned by the node for some reason
            }
            catch (e) {
                // Tx fetching failed, we return an empty array
                return [];
            }
            return txs;
        });
    }
    fetchTransactions(nodeUrl, filterOn, address, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let serializedOptions = "";
            for (const key of Object.keys(options)) {
                serializedOptions += options[key] != null ? `&${key}=${options[key]}` : "";
            }
            const response = yield (0, network_1.default)({
                method: "GET",
                url: `${nodeUrl}/cosmos/tx/${this.version}/txs?events=` +
                    encodeURI(`${filterOn}='${address}'`) +
                    serializedOptions,
            });
            return {
                txs: response.data.tx_responses,
                nextPageToken: response.data.pagination.next_key,
                total: response.data.pagination.total,
            };
        });
    }
}
exports.CosmosAPI = CosmosAPI;
//# sourceMappingURL=Cosmos.js.map